(() => {
    'use strict';

    const appendLoaderImage = (url, readyFn, removeLoaderImage) => {
        const loaderImage = $('<img class="loader-image" src="' + url + '" alt="">');
        real.dom.$body.append(loaderImage);

        const startTime = Date.now();
        loaderImage.on('load', () => {
            const loadTimeMs = Date.now() - startTime;
            if (typeof readyFn === 'function') {
                requestAnimationFrame(() => {
                    loaderImage.removeClass('loader-image');
                    readyFn(url, loaderImage, loadTimeMs);
                });
            }
            if (removeLoaderImage) {
                loaderImage.remove();
            }
        });

        return loaderImage;
    };

    real.image.load = (url, readyFn, removeLoaderImage = true) => {
        if (!url.startsWith('https://')) {
            url = real.baseUri + url;
        }

        const loaderImage = appendLoaderImage(url, readyFn, removeLoaderImage);

        const manipulatedFn = (notification) => {
            if (notification.object.requested_url === url) {
                appendLoaderImage(url, readyFn, removeLoaderImage);
                real.events.off('uploadedfile:image:manipulated', manipulatedFn);
            }
        };

        loaderImage.on('error', () => {
            // Image is not ready yet. Wait for the websocket event.
            real.events.on('uploadedfile:image:manipulated', manipulatedFn);
            loaderImage.remove();
        });
    };
})();
